/**
 * 日期處理工具函數
 * 統一所有 Dialog 中的日期格式轉換邏輯
 */

/**
 * 將 ISO 日期字串轉換為 input[type="date"] 格式
 * @param isoString - ISO 8601 格式的日期字串 (例如: "2024-01-15T00:00:00.000Z")
 * @returns 日期輸入格式 (例如: "2024-01-15")
 */
export const toDateInput = (isoString?: string | null): string => {
  if (!isoString) return '';
  return isoString.split('T')[0];
};

/**
 * 將 input[type="date"] 格式轉換為 ISO 日期字串
 * @param dateString - 日期輸入格式 (例如: "2024-01-15")
 * @returns ISO 8601 格式的日期字串 (例如: "2024-01-15T00:00:00.000Z")，如果為空則返回 null
 */
export const toISOString = (dateString?: string | null): string | null => {
  if (!dateString) return null;
  return `${dateString}T00:00:00.000Z`;
};

/**
 * 獲取今天的日期（input[type="date"] 格式）
 * @returns 今天的日期 (例如: "2024-01-15")
 */
export const getTodayDateInput = (): string => {
  // 用本地日期：toISOString() 是 UTC，台灣早上 8 點前會得到昨天
  const now = new Date();
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
};

/**
 * 到期日是否已過（以日期比較，今天到期不算逾期；與 CRM 任務、儀表板一致）
 * 到期日存成 UTC 午夜（YYYY-MM-DDT00:00:00Z），取日期部分即為使用者選的日期
 */
export const isPastDue = (dueDate?: string | null): boolean =>
  !!dueDate && toDateInput(dueDate) < getTodayDateInput();
